import { teamConfig } from "./team-config";

const STORAGE_KEY = "beat-favorite-team";
const CHANGE_EVENT = "beat-favorite-change";

/** 既存の端末設定から有効な球団slugを返す。SSR・不正値・保存拒否は空文字。副作用なし。 */
export function getFavoriteTeam(): string {
	try {
		const value = window.localStorage.getItem(STORAGE_KEY) ?? "";
		return Object.hasOwn(teamConfig, value) ? value : "";
	} catch { return ""; }
}

/** SSR用の未選択値を返す。引数・副作用なし。 */
export function getServerFavoriteTeam(): string { return ""; }

/** 球団slugを保存する。空文字で解除。不正値・保存失敗はfalse。成功時のみ画面内の購読者へ通知する。 */
export function setFavoriteTeam(slug: string): boolean {
	if (slug && !Object.hasOwn(teamConfig, slug)) return false;
	try {
		if (slug) window.localStorage.setItem(STORAGE_KEY, slug);
		else window.localStorage.removeItem(STORAGE_KEY);
		window.dispatchEvent(new Event(CHANGE_EVENT));
		return true;
	} catch { return false; }
}

/** 同一画面と他タブでの変更を購読し、解除関数を返す。ブラウザー内だけで呼ぶ。 */
export function subscribeFavoriteTeam(callback: () => void) {
	/** 対象の保存キーまたはストレージ全消去だけを通知する。 */
	function onStorage(event: StorageEvent) {
		if (event.key === STORAGE_KEY || event.key === null) callback();
	}
	window.addEventListener("storage", onStorage);
	window.addEventListener(CHANGE_EVENT, callback);
	return () => {
		window.removeEventListener("storage", onStorage);
		window.removeEventListener(CHANGE_EVENT, callback);
	};
}
